<template>
  <div>

    <div class="modal" ref="modalWindow">
      <div class="modal-background"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <job-details :organisation="randomOrg"></job-details>
        </section>

      </div>
    </div>
    <masonry style="margin-top: -10px"
      :cols="{default: 5, 1160: 3, 888: 2, 616: 1}"
      :gutter="{default: '10px', 888: '5px'}"
    >
      <job-list
        v-for="(org, index) in productionOrgList"
        v-bind:key="org.id"
        v-bind:organisation="org">
      </job-list>
    </masonry>
  </div>
</template>
<script>

  import JobList from '@/components/jobs/JobList';
  import JobDetails from '@/components/jobs/JobDetails';
  import axios from 'axios';

  const INITIAL_PAUSE = 10 * 1000;
  const DISPLAY_TIME = 30 * 1000;

  export default {
    props: ['organisation', 'qrcode'],
    components: {
      JobList,
      JobDetails,
    },
    name: 'OrgsList',
    async mounted() {
      // this.$refs.modalWindow.classList.remove('is-active');
      this.organizationResource = this.$resource(`${this.$config.API}/api/orgs`);
      await this.getOrgs();
      this.sortOrg();
      await this.getOrgJobs();
      this.divideJobs();
    },
    methods: {

      divideJobs() {
        this.productionOrgList = this.productionOrgList.filter(orgz => orgz.jobs.length > 0);
        for (let i = 0; i < this.productionOrgList.length; i += 1) {
          const org = this.productionOrgList[i];
          if (org.jobs.length >= 20) {
            const half = Math.round(org.jobs.length / 2);
            const otherHalf = org.jobs.slice(half);
            org.jobs = org.jobs.slice(0, half);
            this.productionOrgList.push({
              id: `${org.id}_2`,
              jobs: otherHalf,
              name: org.name,
            });
          }
        }
      },

      async getOrgJobs() {
        for (let i = 0; i < this.productionOrgList.length; i += 1) {
          const org = this.productionOrgList[i];
          const URL = `${this.$config.API}/api/org/${org.id}/jobs?include=location&pageSize=30`;
          // eslint-disable-next-line
          const { data } = await axios.get(URL);
          const index = this.productionOrgList.findIndex(el => el.id === org.id);
          if (index !== -1) {
            this.productionOrgList[index].jobs = data.data;
          }
        }
      },

      async getOrgs() {
        const organizations = await this.organizationResource.get();
        this.organizations = organizations.data;
        this.randomOrg = this.organizations[0];
        this.showRandomCompany();
      },
      sortOrg() {
        this.productionOrgList = [];
        for (let f = 0; f <= this.fakeArray.length; f += 1) {
          this.organizations.forEach((p) => {
            if (this.fakeArray[f] !== p.id) {
              return;
            }
            this.productionOrgList.push({
              id: p.id,
              name: p.name,
              jobs: p.jobs,
            });
          });
        }
      },
      showRandomCompany() {
        (async () => {
          const delay = time => new Promise(res => setTimeout(() => res(), time));

          await delay(INITIAL_PAUSE);
          const max = Math.floor(Math.random() * this.productionOrgList.length);
          this.randomOrg = this.productionOrgList[max];

          await delay(500);
          this.$refs.modalWindow.classList.add('is-active');

          await delay(DISPLAY_TIME);
          this.$refs.modalWindow.classList.remove('is-active');
          this.showRandomCompany();
        })();
      },
    },
    data() {
      return {
        randomOrg: {
          name: null,
        },
        organizations: [
          {
            name: 'Loading',
            id: null,
            jobs: [],
          },
        ],
        fakeArray: [
          'ricardo',
          'homegate',
          'doodle',
          'tamedia_ag',
          'tutti',
          'starticket',
          'olmero',
          'pux',
        ],
        productionOrgList: [],
        jobs: {
          data: [
            {
              attributes: {
                title: 'Loading data',
              },
            },
          ],
        },
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/home/OrgsList.vue